const PieLoader = ({ color, loading, size }) => 
<div className=" w-fit h-fit border-2 border-white rounded-full">
    <div className={`loader text-${color} ${'w-'+size} ${'h-'+size} ${loading ? '':'hidden'}`}>
    </div>
</div>

export default PieLoader;